import { render, staticRenderFns } from "./BindsToolbar.vue?vue&type=template&id=9987b9f0&"
import script from "./BindsToolbar.vue?vue&type=script&lang=js&"
export * from "./BindsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./BindsToolbar.vue?vue&type=style&index=0&id=9987b9f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports